import { render, staticRenderFns } from "./SpacingSmall.vue?vue&type=template&id=9241b13e"
import script from "./SpacingSmall.vue?vue&type=script&lang=js"
export * from "./SpacingSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports